module.exports = __webpack_public_path__ + "static/media/confounded-face-svgrepo-com.4ed8c5ad.svg";